import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
} from '@mui/material';
import { useAddBrand } from '../../hooks/useBrand';
import { useDivision } from '../../hooks/useDivision';
import { useDivisionTeams } from "../../hooks/useTeam";
const BrandForm = ({ open, onClose, formData, onInputChange, editData = null }) => {
    const addBrand = useAddBrand();
    const { data: divisions } = useDivision();
    const { data: teams } = useDivisionTeams(formData.division_id);
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await addBrand.mutateAsync(formData);
            onClose();
        } catch (error) {
            console.error('Error submitting Brand:', error);
        }
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
            fullWidth
        >
            <DialogTitle className="bg-blueColor text-white py-4">
                <i className={`fas ${editData ? 'fa-edit' : 'fa-plus'} text-xl mx-2`}></i>
                <span className="text-xl font-semibold">
                    {editData ? 'Edit Brand' : 'Add New Brand'}
                </span>
            </DialogTitle>
            <form onSubmit={handleSubmit}>
                <DialogContent className="mt-4">
                    <div className="grid grid-cols-1 gap-4 p-4">
                        <div>
                            <label className="block text-gray-700 text-sm font-bold mb-2">
                                Name
                            </label>
                            <input
                                name="name"
                                value={formData.name}
                                onChange={onInputChange}
                                type="text"
                                required
                                className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-purpleColor"
                            />
                        </div>

                        <div>
                            <label className="block text-gray-700 text-sm font-bold mb-2">
                                Devision
                            </label>
                            <select
                                name="division_id"
                                value={formData.division_id}
                                onChange={onInputChange}
                                required
                                className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-purpleColor"
                            >
                                <option value="">Select a Devision </option>
                                {divisions?.map((divsion) => (
                                    <option key={divsion.id} value={divsion.id}>
                                        {divsion.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div>
                            <label className="block text-gray-700 text-sm font-bold mb-2">
                                Team
                            </label>
                            <select
                                name="team_id"
                                value={formData.team_id}
                                onChange={onInputChange}
                                required
                                className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-purpleColor"
                            >
                                <option value="">Select a Team </option>
                                {teams?.map((team) => (
                                    <option key={team.id} value={team.id}>
                                        {team.name}
                                    </option>
                                ))}
                            </select>
                        </div>

                    </div>

                    <div className="flex justify-end gap-4 mt-6 p-4">
                        <button
                            type="button"
                            onClick={onClose}
                            className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="px-4 py-2 bg-blueColor text-white rounded"
                        >
                            {editData ? 'Save Changes' : 'Add'}
                        </button>
                    </div>

                </DialogContent>
            </form>
        </Dialog>
    );
};

export default BrandForm; 